// ** React Imports
import { useContext } from "react";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";
import Tooltip from "components/layout/Tooltip";

// ** Custom Components
import SelectorSelectSingle from "components/layout/DropdownSelectors/SelectorSelectSingle";
import Block from "components/layout/Block";
import { UserpanelRow } from "containers/Userpanel/components/UserpanelRow";

// ** Utils & Helpers
import useSelectorEducation from "hooks/selectors/useSelectorEducation";

// ** Context
import deviceTypeContext from "contexts/deviceTypeContext";

// #####################################################

const Education = ({
	isCouple,
	data,
	onAccept,
	onAcceptPartner,
	isBan,
	tooltipInfo,
}) => {
	const { t } = useTranslation(["filtersAndSelectors"]);

	const { isPhone } = useContext(deviceTypeContext);

	const { items, selected, setSelected } = useSelectorEducation({
		initial: data.education[0],
	});

	const {
		items: itemsPartner,
		selected: selectedPartner,
		setSelected: setSelectedPartner,
	} = useSelectorEducation({ initial: data.education[1] });

	const tooltipWrapperStyle = {
		display: "flex",
		flexDirection: "row",
		width: "100%",
	};

	const userPartnersSex = useSelector(
		(state) => state.globalUser.partners.sex
	);

	// #####################################################

	return (
		<Tooltip text={tooltipInfo} wrapperStyle={tooltipWrapperStyle}>
			<UserpanelRow fullWidth>
				<Block flex full column={isPhone} withRowGap withColumnGap>
					<SelectorSelectSingle
						label={
							isCouple
								? `${t(
										"filtersAndSelectors:educationLabel"
								  )} / ${t(
										`common:sexOptions.${userPartnersSex[0]}`
								  )}`
								: t("filtersAndSelectors:educationLabel")
						}
						emptyText={t("common:choose")}
						items={items}
						selected={selected}
						onAccept={(value) => {
							setSelected(value);
							onAccept(value);
						}}
						withMobileVersion
						activatorStyleOptions={{
							noPad: true,
							noTopMargin: true,
							noMinWidth: true,
							flex1: true,
						}}
						disabled={isBan}
					/>
					{isCouple && (
						<SelectorSelectSingle
							label={`${t(
								"filtersAndSelectors:educationLabel"
							)} / ${t(
								`common:sexOptions.${userPartnersSex[1]}`
							)}`}
							emptyText={t("common:choose")}
							items={itemsPartner}
							selected={selectedPartner}
							onAccept={(data) => {
								setSelectedPartner(data);
								onAcceptPartner(data);
							}}
							withMobileVersion
							activatorStyleOptions={{
								noPad: true,
								noTopMargin: true,
								noMinWidth: true,
								flex1: true,
							}}
							disabled={isBan}
						/>
					)}
				</Block>
			</UserpanelRow>
		</Tooltip>
	);
};

// #####################################################

export default Education;

// #####################################################
